export const GET_INVOICE_CANCELLATION_REASONS =
  'providers/invoicing/InvoiceCatalogProvider/GET_INVOICE_CANCELLATION_REASONS';
export const GET_INVOICE_TAX_REGIME = 'providers/invoicing/InvoiceCatalogProvider/GET_INVOICE_TAX_REGIME';
